.container {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-2);
  padding: var(--tuna-spacing-2) 0;
}

/* One band: its name, then its switches (GH #2814 M2) */
.band {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-1);
  padding-top: var(--tuna-spacing-1);
}

/**
 * A band the link named (`?band=`) takes focus. It can't be tabbed to, so a light highlight rather than the heavy
 * outline marks it (Joni's audit of M1c/M2, finding 10). Its scroll margin clears the app bar, 52px (header.module.css),
 * and the dev banner.
 */
.heading {
  scroll-margin-top: calc(52px + var(--app-dev-banner-h, 0px) + var(--tuna-spacing-2));
  border-radius: var(--tuna-shape-radius-sm);
  /* The highlight has room around the name, and the name keeps its alignment (Joni's review of #2994, P3 7) */
  padding-inline: var(--tuna-spacing-1);
  margin-inline: calc(-1 * var(--tuna-spacing-1));
}

.heading:focus {
  outline: none;
  background-color: var(--tuna-palette-action-selected);
}

.row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--tuna-spacing-2);
  min-height: 44px;
}

/* A switch's label, and its helper under it (GH #2814 M3b) */
.label {
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-self: stretch;
  cursor: pointer;
}

/* Where the switch applies (Joni, #2936) */
.helper {
  margin: 0;
  color: var(--tuna-content-secondary);
}

.error {
  margin-top: var(--tuna-spacing-1);
}
